import React from 'react';

const getColorClasses = (color) => {
  const colorMap = {
    blue: { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-600 dark:text-blue-400' },
    green: { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-600 dark:text-green-400' },
    orange: { bg: 'bg-orange-100 dark:bg-orange-900/30', text: 'text-orange-600 dark:text-orange-400' },
    purple: { bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-600 dark:text-purple-400' },
    red: { bg: 'bg-red-100 dark:bg-red-900/30', text: 'text-red-600 dark:text-red-400' },
    indigo: { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400' },
    teal: { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-600 dark:text-teal-400' },
  };
  return colorMap[color] || colorMap.blue;
};

const StatCard = ({ title, value, subtitle, icon: Icon, color = 'blue', trend, badge, tooltip }) => {
  const colorClasses = getColorClasses(color);
  
  return (
    <div className="bg-white dark:bg-slate-800 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-white/10" title={tooltip}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className={`p-2 rounded-lg ${colorClasses.bg}`}>
            <Icon className={`w-5 h-5 ${colorClasses.text}`} />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-gray-600 dark:text-slate-400">{title}</p>
            <p className={`text-2xl font-bold ${colorClasses.text}`}>{value}</p>
            {subtitle && (
              <p className="text-xs text-gray-500 dark:text-slate-500">{subtitle}</p>
            )}
          </div>
        </div>
        <div className="text-right">
          {badge && (
            <div className={`text-xs px-2 py-1 rounded-full mb-1 ${badge.color}`}>
              {badge.text}
            </div>
          )}
          {trend && (
            <div className={`text-xs px-2 py-1 rounded-full ${
              trend > 0 
                ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
                : 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400'
            }`}>
              {trend > 0 ? '+' : ''}{trend}%
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;

